import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { IWeissmanModalComponent } from '../../../../Compliance/WeissmanModalService';
import { ModalWrapperComponent } from '../../../../UI-Lib/Modal-Wrapper/modalWrapper.component';
import { ParcelActivitySummaryComponent } from '../../../../Entity/Parcel/Activity/parcel-activity-summary.component';

export interface ParcelActivitySummaryComponentParams {
    siteId: number;
}

@Component({
    selector: 'parcel-activity-summary-modal',
    templateUrl: './parcel-activity-summary-modal.component.html',
    imports: [ModalWrapperComponent, ParcelActivitySummaryComponent],
})
export class ParcelActivitySummaryModalComponent
    implements IWeissmanModalComponent<ParcelActivitySummaryComponentParams, void>
{
    constructor(private readonly _bsModalRef: BsModalRef) {}

    params: ParcelActivitySummaryComponentParams;
    result: void;

    cancel(): void {
        this._bsModalRef.hide();
    }
}
